var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"blank-page"},[_c('div',{staticClass:"block"},[_c('div',{staticClass:"blank-content"},[_c('img',{staticClass:"blank-img",attrs:{"src":_vm.blankImg,"alt":""}}),_c('span',{staticClass:"title-lable"},[_vm._v(_vm._s(_vm.prompt))])]),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }